/**
 * Dependency Injection symbols for clean architecture
 * These symbols are used to bind interfaces to implementations
 */

// Datasource symbols
export const TYPES = {
  // DataSources
  DatabaseDataSource: Symbol.for('DatabaseDataSource'),
  
  // Repositories
  ProductRepository: Symbol.for('ProductRepository'),
  ProductCategoryRepository: Symbol.for('ProductCategoryRepository'),
  UserRepository: Symbol.for('UserRepository'),
  SaleRepository: Symbol.for('SaleRepository'),
  CartRepository: Symbol.for('CartRepository'),
  RefundRepository: Symbol.for('RefundRepository'),
  CustomerRepository: Symbol.for('CustomerRepository'),
  InventoryRepository: Symbol.for('InventoryRepository'),
  StockVoucherRepository: Symbol.for('StockVoucherRepository'),
  BranchRepository: Symbol.for('BranchRepository'),
  AnalyticsRepository: Symbol.for('AnalyticsRepository'),
  BranchInventoryRepository: Symbol.for('BranchInventoryRepository'),
  
  // Use Cases
  // Authentication
  LoginUseCase: Symbol.for('LoginUseCase'),
  LogoutUseCase: Symbol.for('LogoutUseCase'),
  ValidateTokenUseCase: Symbol.for('ValidateTokenUseCase'),
  RefreshTokenUseCase: Symbol.for('RefreshTokenUseCase'),
  
  // Products
  SearchProductsUseCase: Symbol.for('SearchProductsUseCase'),
  SearchProductByBarcodeUseCase: Symbol.for('SearchProductByBarcodeUseCase'),
  GetProductsByCategoryUseCase: Symbol.for('GetProductsByCategoryUseCase'),
  GetProductCategoriesUseCase: Symbol.for('GetProductCategoriesUseCase'),
  GetAllProductsUseCase: Symbol.for('GetAllProductsUseCase'),
  GetProductByIdUseCase: Symbol.for('GetProductByIdUseCase'),
  GetProductsAvailableInBranchUseCase: Symbol.for('GetProductsAvailableInBranchUseCase'),
  SearchProductsAvailableInBranchUseCase: Symbol.for('SearchProductsAvailableInBranchUseCase'),
  GetProductsByCategoryAvailableInBranchUseCase: Symbol.for('GetProductsByCategoryAvailableInBranchUseCase'),
  
  // Sales
  CreateCartUseCase: Symbol.for('CreateCartUseCase'),
  AddItemToCartUseCase: Symbol.for('AddItemToCartUseCase'),
  RemoveItemFromCartUseCase: Symbol.for('RemoveItemFromCartUseCase'),
  UpdateCartItemQuantityUseCase: Symbol.for('UpdateCartItemQuantityUseCase'),
  CancelCartUseCase: Symbol.for('CancelCartUseCase'),
  ProcessSaleUseCase: Symbol.for('ProcessSaleUseCase'),
  ProcessRefundUseCase: Symbol.for('ProcessRefundUseCase'),
  GetSaleHistoryUseCase: Symbol.for('GetSaleHistoryUseCase'),
  
  // Customers
  SearchCustomersUseCase: Symbol.for('SearchCustomersUseCase'),
  GetCustomerByIdUseCase: Symbol.for('GetCustomerByIdUseCase'),
  CreateCustomerUseCase: Symbol.for('CreateCustomerUseCase'),
  UpdateCustomerUseCase: Symbol.for('UpdateCustomerUseCase'),
  GetAllCustomersUseCase: Symbol.for('GetAllCustomersUseCase'),
  
  // Inventory
  GetInventoryByProductUseCase: Symbol.for('GetInventoryByProductUseCase'),
  SearchInventoryUseCase: Symbol.for('SearchInventoryUseCase'),
  GetLowStockItemsUseCase: Symbol.for('GetLowStockItemsUseCase'),
  UpdateStockUseCase: Symbol.for('UpdateStockUseCase'),
  CreateStockVoucherUseCase: Symbol.for('CreateStockVoucherUseCase'),
  GetStockVoucherHistoryUseCase: Symbol.for('GetStockVoucherHistoryUseCase'),
  
  // Analytics
  TrackEventUseCase: Symbol.for('TrackEventUseCase'),
  GetSalesReportUseCase: Symbol.for('GetSalesReportUseCase'),
  GetProductPerformanceUseCase: Symbol.for('GetProductPerformanceUseCase'),
  GetCustomerAnalyticsUseCase: Symbol.for('GetCustomerAnalyticsUseCase'),
} as const; 